var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{attrs:{"menus":_vm.menus,"loanMenus":_vm.loanMenus,"savingMenus":_vm.savingMenus,"slugEn":_vm.slugEn,"slugId":_vm.slugId}}),_vm._v(" "),_c('main',[_c('Floatingbutton'),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('TheFooter',{attrs:{"loanMenus":_vm.loanMenus,"savingMenus":_vm.savingMenus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }